module.exports = __webpack_public_path__ + "static/media/event-services-img28.7935d6a9.jpg";